<nav class="sidebar-nav">
    <ul id="sidebarnav">
        <!-- First level menu -->
        <li class="sidebar-item"
            *ngFor="let sidebarnavItem of sidebarnavItems">
            <div class="nav-small-cap" *ngIf="sidebarnavItem.extralink === true"><i
                [ngClass]="[sidebarnavItem.icon]"></i><span class="hide-menu">{{sidebarnavItem.title}}</span></div>
            <a class="sidebar-link waves-effect waves-dark"
               routerLinkActive="active"
               [routerLink]="sidebarnavItem.class === '' ? [sidebarnavItem.path] : null"
               [ngClass]="[sidebarnavItem.class]" *ngIf="!sidebarnavItem.extralink;"
               (click)="addExpandClass(sidebarnavItem.title)"
               [routerLinkActive]="sidebarnavItem.submenu.length != 0 ? '' : 'active'">
                <i [ngClass]="[sidebarnavItem.icon]"></i>
                <span class="hide-menu">{{sidebarnavItem.title}}</span>
            </a>
        </li>
        <li class="text-center p-40 upgrade-btn">
            <a (click)="logout()" class="btn btn-block btn-danger text-white">Logout</a>
        </li>
    </ul>
</nav>
